import { render, staticRenderFns } from "./TeacherInfos.vue?vue&type=template&id=544cab7a&"
import script from "./TeacherInfos.vue?vue&type=script&lang=js&"
export * from "./TeacherInfos.vue?vue&type=script&lang=js&"
import style0 from "./TeacherInfos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports